'use strict';

module.exports = require('./lib/svgpath');



/*****************
 ** WEBPACK FOOTER
 ** ./~/svgpath/index.js
 ** module id = 278
 ** module chunks = 0
 **/